import { render, staticRenderFns } from "./commandApiModal.vue?vue&type=template&id=125817be&"
import script from "./commandApiModal.vue?vue&type=script&lang=js&"
export * from "./commandApiModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports